<div class="cd-overlay" *ngIf="isVisible" role="dialog" aria-modal="true" aria-labelledby="cdTitle" aria-describedby="cdMessage" (click)="close()">
  <div class="cd-modal" (click)="$event.stopPropagation()">

    <button
      type="button"
      class="cd-close-btn"
      aria-label="Close confirmation dialog"
      (click)="close()">
      &times;
    </button>

    <!-- Warning icon -->
    <div class="cd-icon-wrapper">
      <i class="fa fa-exclamation-triangle cd-icon" aria-hidden="true"></i>
    </div>

    <!-- Title -->
    <h2 class="cd-title" id="cdTitle">{{ title }}</h2>

    <!-- Message -->
    <p class="cd-message" id="cdMessage">{{ message }}</p>

    <!-- Actions -->
    <div class="cd-actions">
      <button class="btn btn-secondary cd-btn-no" (click)="cancel()">
        {{ cancelLabel }}
      </button>
      <button class="btn btn-primary cd-btn-yes" (click)="confirm()">
        {{ confirmLabel }}
      </button>
    </div>

  </div>
</div>
